import jwtAuthService from "../../services/jwtAuthService";
import { setUserData } from "./UserActions";
import history from "../../history.js";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const RESET_PASSWORD_RESPONSE = "RESET_PASSWORD_RESPONSE";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_RESPONSE = "CHANGE_PASSWORD_RESPONSE";


export function loginErrorResponse(error) {
  return {
    type: LOGIN_ERROR,
    ...error,
  };
}

export function resetPasswordErrorResponse(error) {
  return {
    type: RESET_PASSWORD_ERROR,
    ...error,
  };
}


export function changePasswordErrorResponse(error) {
  return {
    type: CHANGE_PASSWORD_ERROR,
    ...error,
  };
}

export function resetPasswordResponse(response) {
  return {
    type: RESET_PASSWORD_RESPONSE,
    response,
  };
}

export function changePasswordResponse(response) {
  return {
    type: CHANGE_PASSWORD_RESPONSE,
    response,
  };
}


export function loginWithEmailAndPassword({ email, password }) {
  return dispatch => {
    dispatch({
      type: LOGIN_LOADING
    });


    jwtAuthService
      .loginWithEmailAndPassword(email, password)
      .then(user => {
        dispatch(setUserData(user));


        history.push({
          pathname: '#/sign-in/Main'
        });


        return dispatch({
          type: LOGIN_SUCCESS
        });
      })
      .catch(error => {

       return dispatch(loginErrorResponse({ error }));
        
      });
  };
}

export function resetPasswordService({ email}) {
  return dispatch => {

    jwtAuthService
      .resetPasswordService(email)
      .then(user => {

        history.push({
          pathname: "/session/temp-password"
        });

        const response = {}
        response.notification = {
          level: 'success',
          message: 'Temporary password sent to your email',
        };
        return dispatch(resetPasswordResponse(response));
      })
      .catch(error => {

       return dispatch(resetPasswordErrorResponse({ error }));
        
      });
  };
}

export function changePasswordService({ email, tempPassword, newPassword, confirmPassword}) {
  return dispatch => {
    if (newPassword === confirmPassword) {

    jwtAuthService
      .changePasswordService(email,newPassword, tempPassword)
      .then(user => {

        history.push({
          pathname: "/session/signin"
        });

        const response = {}
        response.notification = {
          level: 'success',
          message: 'Password successfully changed',
        };
        return dispatch(changePasswordResponse(response));
      })
      .catch(error => {

       return dispatch(changePasswordErrorResponse({ error }));
        
      });

    }
    else {
      const response = {}
      response.notification = {
        level: 'error',
        message: 'New password and confirm password do not match',
      };

      return dispatch(changePasswordResponse(response));

    }

  
  };
}



